import { Timespan } from "./timespan";

export default Timespan;